// Step accordion — one paused GSAP timeline per item, click toggles play/reverse.
// gsap.min.js is loaded at the end of <body> (theme.liquid), after this file —
// DOMContentLoaded fires once every deferred script has run, so gsap exists inside it.
document.addEventListener( 'DOMContentLoaded', () => {
  const mm = gsap.matchMedia()
  const reduceMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' )

  mm.add( { isMobile: '(max-width: 767px)', isDesktop: '(min-width: 768px)' }, ( context ) => {
    const { isMobile } = context.conditions
    const cleanups = []

    document.querySelectorAll( '.step-item' ).forEach( ( item ) => {
      const header = item.querySelector( '.step-item__header' )
      const layout = item.querySelector( '.step-item__layout' )
      const description = item.querySelector( '.step-item__description' )
      const icon = item.querySelector( '.step-item__icon-image' )
      if ( !header ) return

      // MOT-01: GSAP is out of reach of the reduced-motion CSS, so it is gated here.
      // Duration 0 still applies every end state, so the accordion opens and closes
      // normally - it just stops moving.
      const tl = gsap.timeline( {
        paused: true,
        defaults: { duration: reduceMotion.matches ? 0 : 0.3, ease: 'sine.inOut' },
      } )

      // Mobile: open layout is a column. set() at position 0 applies it the
      // moment the timeline plays forward, and restores row only when the
      // reverse fully reaches the start — after the content has collapsed.
      // Inserted first so height:'auto' below measures against the column layout.
      if ( isMobile && layout ) tl.set( layout, { flexDirection: 'column' }, 0 )

      tl.to( header, { marginTop: 0 }, 0 )
      if ( description ) tl.to( description, { height: 'auto' }, 0 )
      if ( icon ) tl.to( icon, { width: 151, height: 185 }, 0 )

      // "Open by default" blocks start expanded
      if ( item.classList.contains( 'step-item--open' ) ) {
        tl.progress( 1 )
      }

      /*
        PDP-02: a collapsed step is `visibility: hidden` in CSS, so its text leaves the
        accessibility tree and anything focusable in it leaves the tab order. The class
        alone would hide it the instant the button is pressed, before the collapse has
        animated, so the closing step is pinned visible inline and released only once
        the reverse has actually finished.

        This does not use `tl.set(..., 0)` like the mobile layout above it: that value
        is NOT restored on reverse - measured - so after the first open the panel would
        have stayed in the accessibility tree for good.
      */
      const releasePanel = () => {
        if ( description ) description.style.visibility = ''
      }
      if ( description ) tl.eventCallback( 'onReverseComplete', releasePanel )

      const onClick = () => {
        const open = item.classList.toggle( 'step-item--open' )
        // The class was the only thing that changed. Nothing told assistive technology
        // whether the step was open, so the state was never reported.
        header.setAttribute( 'aria-expanded', String( open ) )
        if ( description ) description.style.visibility = open ? '' : 'visible'
        if ( open ) {
          tl.play()
        } else {
          tl.reverse()
          // Under reduced motion the timeline has no duration and never fires
          // onReverseComplete, so the panel would have stayed in the accessibility
          // tree - measured. Release it directly in that case.
          if ( !tl.duration() ) releasePanel()
        }
      }
      header.addEventListener( 'click', onClick )
      cleanups.push( () => header.removeEventListener( 'click', onClick ) )
    } )

    // When the breakpoint flips, gsap reverts the timelines' inline styles;
    // remove our click listeners too so the new context doesn't double-bind
    return () => cleanups.forEach( ( fn ) => fn() )
  } )
} )
